<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="108" height="21" viewBox="0 0 108 21" fill="none">
        <ellipse cx="54" cy="9.5" rx="54" ry="9.5" fill="#633000"/>
        <ellipse cx="54" cy="10" rx="39" ry="5" fill="#823E00" fill-opacity="0.64"/>
        <rect x="35" y="16" width="37" height="5" rx="2" fill="#633000"/>
      </svg>
</template>